<style src="./NewEvent.scss" lang="scss" scoped></style>
<template>
  <section class="new-event">
    <transition name="transition-tab-item">
      <bid-capture
        @close-panel="closePanel"/>
    </transition>
  </section>
</template>

<script>
import { PanelTab, PanelTabItem } from '@/components/primitives'
import FormDataInput from './form-data-input/FormDataInput'
import FormFileInput from './form-file-input/FormFileInput'
import BidCapture from '@/components/event/bid-capture/BidCapture'

export default {
  name: 'NewEvent',
  components: {
    PanelTab,
    PanelTabItem,
    FormDataInput,
    FormFileInput,
    BidCapture
  },
  data () {
    return {
      panelTab: {
        panelTabChoose: 'INSERIR'
      }
    }
  },
  methods: {
    closePanel () {
      this.$parent.$emit('close', false)
    },
    changePanelTab (pPanelItemId) {
      this.panelTab.panelTabChoose = pPanelItemId
    },
    eventSaved () {
      this.$emit('refresh-list', false)
      this.closePanel()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/event/components/new-event/NewEvent.vue